import { Button, IconButton } from "@mui/material";
import Tooltip from 'react-bootstrap/Tooltip';
import CachedIcon from '@mui/icons-material/Cached';
import { Modal, OverlayTrigger } from "react-bootstrap";
import useInventoryManagement from "./hooks/useInventoryManagement";
import { ToastContainer } from "react-toastify";
import Spinner from "../../Components/spinner/spinner";
import { useNavigate } from "react-router-dom";
import Paginations from "../../Components/Pagination/pagination";
import AddStock from "./AddStock";

const InventoryManagement = () => {

    const {
        setShowModal,
        openEditModal,
        setTab,
        submitInventortManagement,
        handleChange,
        handleOpenModalMode,
        categoryDelete,
        categoryChangeStatusApi,
        vendorDelete,
        vendorChangeStatusApi,
        handleVendorChange,
        setPage,
        setStockModal,
        handleChangeStock,
        updateStock,
        setPageCategory,
        setPageVendor,
        inventoryDownload,
        inventoryDelete,
        handleInventoryFiltersChange,
        handleInventorySearch,
        handleCategoryFiltersChange,
        handleCategorySearch,
        handleVendorFiltersChange,
        handleVendorSearch,
        vendorSearchFilter,
        categorySearchFilter,
        inventorySearchFilter,
        pageVendor,
        vendorCount,
        stockForm,
        stockModal,
        showModal,
        mode,
        tab,
        formData,
        listCategory,
        spinner,
        listVendor,
        count,
        page,
        categoryCount,
        pageCategory,
        PER_PAGE,
        listInventory,
    } = useInventoryManagement()

    const navigate = useNavigate()

    return (
        <>
            <section className='position-relative'>
                <ToastContainer />
                <div className="m-t-3 cus-padd cusheight position-relative">
                    {spinner ? <Spinner /> : null}
                    <header style={{ paddingTop: '-10px' }}>
                        <nav className="mb-3">
                            <div className="nav nav-tabs tabber border-bottom-0" id="nav-tab" role="tablist">
                                <button className={` ${tab === 'INVENTORY' ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => { setTab('INVENTORY') }} id="basicdetails" type="button">
                                    Inventory Management
                                </button>
                                <button className={` ${tab === 'CATEGORY' ? 'activeNav' : 'unActiveNav'} border-0`} type="button" onClick={() => { setTab('CATEGORY') }} >
                                    Category
                                </button>
                                <button className={` ${tab === 'VENDOR' ? 'activeNav' : 'unActiveNav'} border-0`} type="button" onClick={() => { setTab('VENDOR') }} >
                                    Vendor
                                </button>
                            </div>
                        </nav>
                        <hr />
                    </header>

                    {tab === 'INVENTORY' &&
                        <div>
                            <div className="d-flex justify-content-end">
                                <div className="d-flex justify-content-right align-items-center gap-2">
                                    <div className="w-50">
                                        <input type="text" name="search" placeholder="Search by name" value={inventorySearchFilter.search} onChange={handleInventoryFiltersChange} className="form-control" />
                                    </div>
                                    <button onClick={handleInventorySearch}
                                        className="btn yesbtn">
                                        Search
                                    </button>
                                    <button onClick={inventoryDownload}
                                        className="btn yesbtn">
                                        Download
                                    </button>
                                    <IconButton onClick={() => window.location.reload()}>
                                        <CachedIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table cus-table">
                                    <thead className="text-center tableheader">
                                        <tr>
                                            <th scope="col">Product ID</th>
                                            <th scope="col">Product Name</th>
                                            <th scope="col">Category</th>
                                            <th scope="col">Brand/Manufacture</th>
                                            <th scope="col">Stock Quantity</th>
                                            <th scope="col">MRP</th>
                                            <th scope="col">Vendor</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listInventory?.map((item) => (
                                            <tr value={item._id} key={item._id} className="text-center">
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.productId || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.productName || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.category?.name || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.brand || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.stockQuantity || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.mrp || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.vendor?.name || ''}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>
                                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                                    </Button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="dropdown-item cursor"
                                                                onClick={() => {
                                                                    navigate(`/layout/inventoryManagement/update-inventory/${item._id}`);
                                                                }}
                                                            >
                                                                Update
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="dropdown-item cursor"
                                                                onClick={() => {
                                                                    setStockModal({
                                                                        show: true,
                                                                        inventoryId: item._id,
                                                                        action: 'ADD'
                                                                    });
                                                                }}
                                                            >
                                                                Add Stock
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="dropdown-item cursor"
                                                                onClick={() => {
                                                                    setStockModal({
                                                                        show: true,
                                                                        inventoryId: item._id,
                                                                        action: 'RELEASED'
                                                                    });
                                                                }}
                                                            >
                                                                Release Stock
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="dropdown-item cursor"
                                                                onClick={() => inventoryDelete(item._id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className='w-100 d-flex justify-content-center'>
                                    {
                                        count > 10 &&
                                        <Paginations setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {tab === 'CATEGORY' &&
                        <div>
                            <div className="d-flex justify-content-end">

                                <div className="d-flex justify-content-right align-items-center gap-2">

                                    <div className="w-100">
                                        <input onChange={handleCategoryFiltersChange} value={categorySearchFilter.search} name="search" placeholder="Search by name" type="text" className="form-control" />
                                    </div>
                                    <button onClick={handleCategorySearch} className="btn yesbtn">
                                        Search
                                    </button>
                                    <IconButton onClick={() => window.location.reload()}>
                                        <CachedIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table cus-table">
                                    <thead className="text-center tableheader">
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(listCategory) && listCategory.map((item) => (
                                            <tr id={item.value} key={item.value} className="text-center">
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.name}</td>
                                                <td style={{ padding: '0.4rem .5rem' }} className="d-flex justify-content-center">
                                                    <span className="form-check form-switch">
                                                        <input onClick={() => categoryChangeStatusApi(item._id, item?.isActive)} onChange={handleChange} checked={item?.isActive} className="form-check-input" type="checkbox" />
                                                    </span>
                                                </td>
                                                <td style={{ padding: '0.4rem .5rem' }} >
                                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                                    </Button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="dropdown-item cursor"
                                                                onClick={() => openEditModal(item)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="dropdown-item cursor"
                                                                onClick={() => categoryDelete(item._id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className='w-100 d-flex justify-content-center'>
                                    {
                                        categoryCount > 10 &&
                                        <Paginations setpage={setPageCategory} count={Math.ceil(categoryCount / PER_PAGE)} page={pageCategory} />
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {tab === 'VENDOR' &&
                        <div>
                            <div className="d-flex justify-content-end">

                                <div className="d-flex justify-content-right align-items-center gap-2">

                                    <div className="w-100">
                                        <input onChange={handleVendorFiltersChange} value={vendorSearchFilter.search} name="search" placeholder="Search by name" type="text" className="form-control" />
                                    </div>
                                    <button onClick={handleVendorSearch} className="btn yesbtn">
                                        Search
                                    </button>
                                    <IconButton onClick={() => window.location.reload()}>
                                        <CachedIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table cus-table">
                                    <thead className="text-center tableheader">
                                        <tr>
                                            <th scope="col">Vender ID</th>
                                            <th scope="col">Vender/Company Name</th>
                                            <th scope="col">Category</th>
                                            <th scope="col">Phone Number</th>
                                            <th scope="col">Rating/Score</th>
                                            {/* <th scope="col">Approval Status</th> */}
                                            <th scope="col">Tax registration no.</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listVendor.map((item) => (
                                            <tr id={item.value} key={item.value} className="text-center">
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.vendorId}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.name}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.category}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.phoneNumber}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.rating}</td>
                                                {/* <td style={{ padding: '0.4rem .5rem' }}>{item?.approvalStatus}</td> */}
                                                {/* <td style={{ padding: '0.4rem .5rem' }}>-</td> */}
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.taxRegistration}</td>
                                                <td style={{ padding: '0.4rem .5rem' }} className="d-flex justify-content-center">
                                                    <span className="form-check form-switch">
                                                        <input onClick={() => vendorChangeStatusApi(item._id, item?.isActive)} onChange={handleVendorChange} checked={item?.isActive} className="form-check-input" type="checkbox" />
                                                    </span>
                                                </td>
                                                <td style={{ padding: '0.4rem .5rem' }}>
                                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                                    </Button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                        <li>
                                                            <button
                                                                className="dropdown-item cursor"
                                                                onClick={() => {
                                                                    navigate(`/layout/inventoryManagement/update-vendor/${item._id}`);
                                                                }}
                                                            >
                                                                Update
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button
                                                                className="dropdown-item cursor"
                                                                onClick={() => vendorDelete(item._id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className='w-100 d-flex justify-content-center'>
                                    {
                                        vendorCount > 10 &&
                                        <Paginations setpage={setPageVendor} count={Math.ceil(vendorCount / PER_PAGE)} page={pageVendor} />
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <Modal centered show={showModal} onHide={() => setShowModal(false)}>
                    <div className="modal-body">
                        <h6 className="text-center"> {mode === 'add' ? 'Add Category' : 'Edit Category'}</h6>
                        <div className="py-3">
                            <div className="cus-form">
                                <label htmlFor="">Name</label> <br />
                                <input type="text" name='name' value={formData.name} onChange={handleChange} className="form-control w-100" placeholder="" />
                            </div>
                        </div>

                        <div className="d-flex gap-4">
                            <button type="button" className="btn yesbtn" data-bs-dismiss="modal" onClick={() => setShowModal(false)}>
                                Cancel
                            </button>
                            <button onClick={submitInventortManagement}
                                type="button"
                                className="btn yesbtn"
                            >
                                {mode === 'add' ? "Submit" : "Update"}
                            </button>
                        </div>
                    </div>
                </Modal>
                <div className="">
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {tab === 'INVENTORY' ? 'Inventory' : tab === 'CATEGORY' ? 'Category' : tab === 'VENDOR' ? 'Vendor' : ''} </Tooltip>}>
                        <p className="btn addbtn2">
                            <i onClick={handleOpenModalMode} className="fa-solid fa-plus"></i>
                        </p>
                    </OverlayTrigger>
                </div>

                {/* <AddStock setShow={setShowAddStock} show={showAddStock} /> */}
                <AddStock
                    setShow={(value) => { setStockModal(prev => ({ ...prev, show: value })); }}
                    show={stockModal.show}
                    inventoryId={stockModal.inventoryId}
                    handleChange={handleChangeStock}
                    action={stockModal.action}
                    stockForm={stockForm}
                    updateStock={updateStock}
                />
            </section>
        </>
    )
}

export default InventoryManagement;